import { BaseComponent } from "../../../BaseComponent.js";
import { defineElement } from "../../../../decorators/defineElement.js";
import { prop } from "../../../../decorators/prop/index.js";
import { html } from "lit";
import { getFill } from "../utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfIsotype = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_variant = "primary";
  }
  render() {
    const fill = getFill(this.dsf_variant);
    return html`
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          style="fill: ${fill}"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0001 1.16235C6.94484 1.16235 0.415161 7.69203 0.415161 15.7472C0.415161 23.8025 6.94484 30.3321 15.0001 30.3321C23.0553 30.3321 29.5849 23.8025 29.5849 15.7472C29.5849 7.69203 23.0553 1.16235 15.0001 1.16235ZM11.8265 13.79C11.8556 13.8336 11.8888 13.8772 11.9199 13.9187C11.9967 14.0204 12.0818 14.1159 12.1752 14.2093C12.306 14.34 16.482 18.516 16.482 18.516C16.9386 18.9726 16.868 19.8049 16.4052 20.2678C15.8573 20.8157 15.1536 20.7223 14.697 20.301L10.1184 15.7223C9.45003 15.054 9.10756 14.1615 8.90831 13.2939C8.72566 12.4949 8.72359 11.6646 8.90001 10.8656C9.03285 10.2657 9.26738 9.68456 9.60155 9.147C9.60362 9.14492 9.6057 9.14077 9.60777 9.13869L8.70906 8.23998H12.4035V11.9345L11.5048 11.0357C11.5027 11.0399 11.5027 11.042 11.5007 11.0461C11.1582 11.9448 11.2661 12.9764 11.8265 13.79ZM18.6074 24.1304C18.0864 24.4521 17.526 24.6783 16.9469 24.8112C16.1375 24.9959 15.2948 24.998 14.4853 24.8132C13.6426 24.6223 12.719 24.2196 12.0777 23.5762L7.49694 18.9976C7.10258 18.5866 7.03201 17.8145 7.55298 17.2935C8.07394 16.7726 8.84605 16.7373 9.30267 17.1918L13.8855 21.7746C14.477 22.3662 15.7556 22.5094 16.675 22.2001C16.7103 22.1877 16.7435 22.1752 16.7767 22.1628V24.0744H18.6966C18.6675 24.091 18.6364 24.1117 18.6074 24.1304ZM17.5966 23.2545V19.56L18.4953 20.4587C18.4974 20.4546 18.4974 20.4525 18.4994 20.4484C18.844 19.5497 18.734 18.5181 18.1736 17.7045C18.1445 17.6609 18.1113 17.6173 18.0802 17.5758C18.0034 17.4741 17.9183 17.3786 17.8249 17.2852C17.6941 17.1545 13.5181 12.9785 13.5181 12.9785C13.0615 12.5218 13.1321 11.6895 13.5949 11.2267C14.1428 10.6788 14.8465 10.7722 15.3031 11.1935L19.8817 15.7722C20.5501 16.4405 20.8925 17.333 21.0918 18.2005C21.2744 18.9996 21.2765 19.8299 21.1001 20.6289C20.9673 21.2288 20.7327 21.8099 20.4006 22.3475C20.3986 22.3496 20.3965 22.3537 20.3944 22.3558L21.2931 23.2545H17.5966ZM22.445 14.201C21.9241 14.7219 21.152 14.7572 20.6954 14.3027L16.1146 9.71985C15.5231 9.12831 14.2446 8.9851 13.3251 9.29436C13.2898 9.30681 13.2566 9.31927 13.2234 9.33172V7.42014H11.3035C11.3346 7.40146 11.3637 7.3807 11.3948 7.36202C11.9158 7.04031 12.4762 6.81408 13.0553 6.68124C13.8647 6.49652 14.7074 6.49444 15.5169 6.67917C16.3595 6.87012 17.2832 7.27277 17.9245 7.91619L22.5032 12.4949C22.8954 12.9079 22.966 13.68 22.445 14.201Z"
        />
      </svg>
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfIsotype.prototype, "dsf_variant", 2);
DsfIsotype = __decorateClass([
  defineElement("dsf-isotype")
], DsfIsotype);
export {
  DsfIsotype
};
